import { EvalMode } from './const'

export function recordResult(mode, text, res) {
    const resVal = {
        pronAccuracy: res.PronAccuracy < 0 ? 0 : res.PronAccuracy,
        pronCompletion:
            (res.PronCompletion < 0 ? 0 : res.PronCompletion) * 100,
        pronFluency: (res.PronFluency < 0 ? 0 : res.PronFluency) * 100,
        suggestedScore: res.SuggestedScore,
        audioUrl: res.AudioUrl,
    }

    // 命中单词
    resVal.hitWords = wordComplete(res.Words)

    // 自由说模式计算完整度 ,TODO:3需要枚举化
    const words = text ? text.match(/[a-zA-Z]+/gi) : []
    if (mode === EvalMode.FREE) {
        resVal.suggestedScore =
            (resVal.hitWords.length / words.length) * 100
        resVal.pronCompletion =
            (resVal.hitWords.length / words.length) * 100
    }

    return resVal
}

export function wordComplete(words) {
    let keyWords = []
    for (let i = 0; i < words.length; i++) {
      // 命中
      if (words[i].MatchTag === 0) {
        keyWords.push(words[i].Word)
      }
    }

    return keyWords
}

// 部分模式需要重新计算分数
export function resetScore(keywords, mode, data) {
  let keywordsArr = keywords
    ? keywords.match(/[a-zA-Z\']+/gi)
    : []

  keywordsArr = keywordsArr.map((item) => {
    return item.toLowerCase()
  })

  // 包含中心词需要重新计算完整度
  if (keywordsArr.length) {
    // 命中中心词个数
    let realHitWords = []
    for (let i = 0; i < data.hitWords.length; i++) {
      // 计算命中个数而不是次数
      if (
        realHitWords.indexOf(data.hitWords[i].toLowerCase()) < 0 &&
        keywordsArr.indexOf(data.hitWords[i].toLowerCase()) > -1
      ) {
        realHitWords.push(data.hitWords[i])
      }
    }
    data.pronCompletion = (realHitWords.length / keywordsArr.length) * 100
  }

  if (mode === EvalMode.FREE) {
    // 自由说：准确度15%、完整度60%、流利度25%
    return (
      data.pronAccuracy * 0.15 +
      data.pronCompletion * 0.6 +
      data.pronFluency * 0.25
    )
  } else {
    // 段落：准确度30%、完整度50%、流畅度20%
    return (
      data.pronAccuracy * 0.3 +
      data.pronCompletion * 0.5 +
      data.pronFluency * 0.2
    )
  }
}

// 元素测评类型
export function getMode(elementType) {
  return {
    [815]: EvalMode.FREE, // 跟读
    [824]: EvalMode.FREE, // 大情景段跟读
    [816]: EvalMode.FREE, // 自读
    [825]: EvalMode.FREE, // 大情景段自读
    [831]: EvalMode.FREE, // 语音复述
    [803]: EvalMode.PARAGRAPH, // 语音测试-中心词
    [820]: EvalMode.PARAGRAPH, // 段提问-中心词
    [821]: EvalMode.FREE, // ABC讲解
    [822]: EvalMode.PARAGRAPH, // 扩听故事-中心词
  }[elementType]
}
